<template>
    <div>
        <div v-show="!loading" class="col-xs-3" style="height: 100%; padding:0">
            <dashboard-item-menu
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="phishingMenuList"
                @menuItemClicked="onMenuItemClick"></dashboard-item-menu>
        </div>
        <div v-show="!loading" class="col-xs-9" style="height: 100%; overflow: hidden">
            <image-slider ref="imageSlider" :images="imageSliderItems" @imageClicked="onImageClick"></image-slider>
        </div>
        <div v-show="!loading" class="enlarge-button grow" @click="onEnlargeClick">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <image-display-modal ref="imageDisplayModal"></image-display-modal>
        <loading-modal v-if="loading" :color="'green'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import ImageSlider from '@/components/image-slider/ImageSlider.vue'
    import ImageDisplayModal from '@/components/modals/ImageDisplayModal.vue'
    import Constants from '@/utils/constants'
    import Common from '@/utils/Common.vue'

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';

    import LoadingModal from "@/components/modals/LoadingModal";

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "rgb(0,255,174)";
    const MENU_ITEM_TEXT_COLOR = "white";
    const MENU_TITLE_COLOR = "white";

    const ALL_TYPES = "ALL TYPES";
    const ALL_BRANDS = "ALL BRANDS";

    const MENU_ITEM_TYPE_PHISHING_TYPE = "phishing_type";
    const MENU_ITEM_TYPE_BRAND_TYPE = "brand_type";

    const PHISHING_TYPE_SITE = "site";
    const PHISHING_TYPE_EMAIL = "email";

    export default {
        name: "targeted-phishing",
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        components: {
            LoadingModal: LoadingModal,
            DashboardItemMenu: DashboardItemMenu,
            ImageSlider: ImageSlider,
            ImageDisplayModal: ImageDisplayModal
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'TARGETED\nPHISHING WEBSITES\n& EMAILS',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                brands: [],
                selectedBrandName: ALL_BRANDS,
                selectedType: ALL_TYPES,
                phishingMenuList: [],
                phishingData: [],
                loading: false,
                pageName: 'Targeted Phishing Widget'
            }
        },
        computed: {
            imageSliderItems() {
                var newImageSliderItems = [];
                for (let i = 0; i < this.phishingData.length; i++) {
                    let pd = this.phishingData[i];
                    if ((this.selectedBrandName == ALL_BRANDS || this.selectedBrandName == pd.brand.toUpperCase()) &&
                        (this.selectedType == ALL_TYPES || this.selectedType == pd.type))
                        newImageSliderItems.push({
                            mainTitle: pd.brand.toUpperCase(),
                            subTitle: pd.url,
                            url: pd.ss,
                            date: pd.created_at
                        });
                }
                return newImageSliderItems;
            },
            ...mapGetters([
                "getDashboardEnlargedItem"
            ])
        },
        methods: {
            isTypeSelected(type) {
                return this.selectedType == type;
            },
            isBrandSelected(brand) {
                return this.selectedBrandName == brand;
            },
            createBrandMenuItem(text, value) {
                return {
                    text: text,
                    color: MENU_ITEM_TEXT_COLOR,
                    selected: this.isBrandSelected(value),
                    type: MENU_ITEM_TYPE_BRAND_TYPE,
                    value: value
                };
            },
            createPhishingTypeMenuItems() {
                return [
                    {
                        text: "ALL TYPES",
                        color: MENU_TITLE_COLOR,
                        selected: this.isTypeSelected("ALL TYPES"),
                        type: MENU_ITEM_TYPE_PHISHING_TYPE,
                        value: "ALL TYPES"
                    },
                    {
                        text: "SITE PHISHING",
                        color: MENU_TITLE_COLOR,
                        selected: this.isTypeSelected(PHISHING_TYPE_SITE),
                        type: MENU_ITEM_TYPE_PHISHING_TYPE,
                        value: PHISHING_TYPE_SITE
                    },
                    {
                        text: "EMAIL PHISHING",
                        color: MENU_TITLE_COLOR,
                        selected: this.isTypeSelected(PHISHING_TYPE_EMAIL),
                        type: MENU_ITEM_TYPE_PHISHING_TYPE,
                        value: PHISHING_TYPE_EMAIL
                    }
                ];
            },
            createBrandList() {
                var b = {};
                for (let i = 0; i < this.phishingData.length; i++) {
                    b[this.phishingData[i].brand.toUpperCase()] = 1;
                }
                this.brands = Object.keys(b);
            },
            createPhishingBrandMenu() {
                var self = this;
                var phishingTypeMenuItems = self.createPhishingTypeMenuItems();
                var brandMenuItems = [self.createBrandMenuItem("ALL BRANDS", "ALL BRANDS")];
                for (let i = 0; i < this.brands.length; i++) {
                    brandMenuItems.push(self.createBrandMenuItem(self.brands[i].toUpperCase(), self.brands[i]));
                }

                this.phishingMenuList = [
                    {
                        type: "dropdown",
                        text: this.selectedBrandName,
                        color: MENU_TITLE_COLOR,
                        backgroundColor: "rgb(0,193,131)",
                        open: false,
                        items: brandMenuItems
                    },
                    {
                        type: "dropdown",
                        text: this.selectedType,
                        color: MENU_TITLE_COLOR,
                        backgroundColor: "rgb(0,130,87)",
                        open: false,
                        items: phishingTypeMenuItems
                    }
                ];
            },
            getPhishingData() {
                let log_start = Date.now();
                this.loading = true;
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/phishing/list';
                this.$http.post(path)
                    .then(response => {
                        this.phishingData = response.body.data;
                        this.createBrandList();
                        this.createPhishingBrandMenu();
                        this.loading = false;
                        this.$emit('loaded', 'targeted-phishing', this.getDurationInSeconds(log_start, Date.now()));
                    }, response => {
                        this.loading = false;
                    });

            },
            onMenuItemClick(item) {
                let log_start = Date.now();
                if (item.type == MENU_ITEM_TYPE_PHISHING_TYPE) {
                    this.selectedType = item.value;
                    this.saveLog(this, this.pageName, this.pageName + ' type clicked. Type name: (' + item.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                if (item.type == MENU_ITEM_TYPE_BRAND_TYPE) {
                    this.selectedBrandName = item.value;
                    this.saveLog(this, this.pageName, this.pageName + ' brand clicked. Brand name: (' + item.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);

                }
                this.$refs.imageSlider.refreshImage();
            },
            onEnlargeClick() {
                let log_start = Date.now();
                let enLargeClicked = this.getDashboardEnlargedItem;
                if (enLargeClicked != null) {
                    this.saveLog(this, this.pageName, this.pageName + ' minimized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                else {
                    this.saveLog(this, this.pageName, this.pageName + ' maximized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            onImageClick(src, url) {
                let log_start = Date.now();
                this.$refs.imageDisplayModal.openModal(src, url);
                this.saveLog(this, this.pageName, this.pageName + ' image clicked. Image source: (' + src + ')', this.getDurationInSeconds(log_start, Date.now()), null);
            },
            ...mapActions([
                "setDashboardEnlargedItem"
            ])
        },
        mounted() {
            this.getPhishingData();
        }
    }
</script>

<style scoped>
    #page {
        height: 94%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/targeted-phishing/TargetedPhishing.vue